import React, { useState } from 'react'
import Cover from './Cover/Cover'
import Couple from './Couple/Couple'
import Savethedate from '../../FinalOutput/Components/SaveTheDate/Savethedate';
import Countdown from '../../FinalOutput/Components/Countdown/Countdown';
import Events from '../../FinalOutput/Components/Events/Events';
import Sliderpre from './Slider/Sliderpre';
import Rsvpfooter from '../../FinalOutput/Components/RSVP&Footer/Rsvpfooter';
import Envelope from '../../FinalOutput/Components/Envelope/Envelope';
import MusicButton from '../../../helpers/MusicButton';
import { useSelector } from 'react-redux';
import PreviewMark from '../../../helpers/PreviewMark';
import Trialbadge from '../../../helpers/Trialbadge';
import Watermark from '../../../helpers/Watermark';
import PhotoControls from '../../../helpers/PhotoControls';

const Theme5 = ({details,events,demoExpired,isPreview,photoControls,playMusic,toggleMusic,isMusicPlaying,iconAnimate}) => {
  const {user} = useSelector(state => state.auth);  
  const [photoMode, setPhotoMode] = useState();
     const [envelopeScreen, SetEnvelopeScreen] = useState(true)

  return (
   <>
     {isPreview && <PreviewMark /> }

        {!isPreview && user?.demoVersion && !demoExpired && (
  <Trialbadge demoExpiryTime={user.demoExpiryTime} />
)}

{!isPreview && user?.demoVersion && !demoExpired && (
  <Watermark   theme={details?.theme} />
)}


 {photoControls && !envelopeScreen && (
        <PhotoControls
          photoMode={photoMode}
          setPhotoMode={setPhotoMode}
        />
      )}

   {envelopeScreen ? <Envelope SetEnvelopeScreen={SetEnvelopeScreen}  details={details} demoExpired={demoExpired} onOpen={playMusic} iconAnimate={iconAnimate} /> : <> 
   
      <MusicButton
  enabled={details.music?.enabled}
  isMusicPlaying={isMusicPlaying}
  toggleMusic={toggleMusic}
  theme={details?.theme}
/>

    <Cover  details={details} photoMode={photoMode} />
    <Savethedate details={details} />
    <Countdown  details={details} />
    <Couple   details={details} photoMode={photoMode} />
     <Events  events={events} theme={details?.theme} />
       <Sliderpre   details={details}   />
        <Rsvpfooter  details={details} />   
   </> }

   </>
  )
}

export default Theme5